(function() { window.GUID_27c8051f_46b3_4444_b273_fa29f4f13f6c = { getGuid: function() { return "27c8051f-46b3-4444-b273-fa29f4f13f6c"; } }; })();
var SchedulesGenerator;
(function (SchedulesGenerator) {
    var desktop;
    (function (desktop) {
        function BindPreSchedulesControls() {
            var btnAddPreScheduleGroup = $('#BtnAddPreScheduleGroup');
            var btnClosePreScheduleGroup = $('#BtnClosePreScheduleGroup');
            var preSchedulesGroupRows = $('.PreSchedulesGroupsList');
            var preScheduleDates = $('.PreScheduleDates');
            var hiddenGroupId = $('#PreSchedulesActualGroupId');
            var hiddenAttemptId = $('#PreSchedulesActualAttemptId');
            var hiddenShowAllSchedule = $('#ShowAllSchedule');
            let gridViewPreScheduleDatesUI = $('#GridViewPreScheduleDates');
            let gridViewPreScheduleDates = gridViewPreScheduleDatesUI.data('context');
            CS.body.on('Refreshed', '#GridViewPreScheduleDates', function (e, gridView) {
                gridViewPreScheduleDates = gridView;
            });
            let $txtSearchPreSchedules = $('#TxtSearchPreSchedules');
            $txtSearchPreSchedules.off('keyup.preschedules');
            $txtSearchPreSchedules.on('keyup.preschedules', function () {
                let rows = $('.PreScheduleGroupRow');
                let text = $txtSearchPreSchedules.val().toLowerCase();
                if ($txtSearchPreSchedules.val() == "") {
                    rows.show();
                }
                else {
                    rows.hide();
                }
                $.map(rows, function (element, index) {
                    let $element = $(element);
                    let $groupName = $element.find('.GroupName');
                    let $flowBlocks = $element.find('.FlowBlocks');
                    if ($groupName[0].innerHTML.toLowerCase().indexOf(text) > -1 || $flowBlocks[0].innerHTML.toLowerCase().indexOf(text) > -1) {
                        $element.show();
                    }
                });
            });
            let requestedSchedulingGroupInput = $('#RequestedSchedulingGroupId');
            let requestedSchedulingGroupId = requestedSchedulingGroupInput.val();
            if (requestedSchedulingGroupId) {
                let requestedGroup = GetGroupElement(requestedSchedulingGroupId);
                if (requestedGroup.length > 0) {
                    $('.PreScheduleGroupRow').removeClass('IsSelected IsRequested');
                    requestedGroup.addClass('IsSelected IsRequested');
                    hiddenGroupId.val(requestedSchedulingGroupId);
                    requestedGroup.get(0).scrollIntoView(false);
                    requestedSchedulingGroupInput.val('');
                }
            }
            btnAddPreScheduleGroup.off('click');
            btnAddPreScheduleGroup.on('click', function (e) {
                e.preventDefault();
                let data = {
                    isNew: true
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "",
                    Url: CSParameters.RUrl + 'SchedulesGenerator/EditPreSchedulesGroup/' + CSParameters.SportEventId,
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                });
                popup.OnPosted = function (response) {
                    //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
                    if ($('form', response).length == 0) {
                        var newRow = $(response);
                        newRow.prependTo(preSchedulesGroupRows);
                    }
                };
                /*
               ShowFormPopup(CSParameters.RUrl + 'SchedulesGenerator/EditPreSchedulesGroup/' + CSParameters.SportEventId, data, null,
                   function (response) {
                       //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
                       if ($('form', response).length == 0) {
                           var newRow = $(response);
                           newRow.appendTo(preSchedulesGroupRows);
                           $(this).dialog("close");
                       }
                   });
               */
            });
            btnClosePreScheduleGroup.off('click');
            btnClosePreScheduleGroup.on('click', function (e) {
                e.preventDefault();
                $('#BtnPreSchedules').trigger('click');
            });
            var lastMenu = null;
            var menuDisplayed = false;
            CS.doc.off('click.preschedule');
            CS.doc.on('click.preschedule', function (e) {
                // Ne pas cacher le menu si dans un tutoriel
                //if (!menuDisplayed && ((typeof (tutorialPointer) == 'undefined') || tutorialPointer.length == 0 || !tutorialPointer.is(":visible"))) {
                ClearLastMenu();
                //}
                menuDisplayed = false;
            });
            preSchedulesGroupRows.off('click');
            preSchedulesGroupRows.on('click', function (e) {
                $('.PreScheduleGroupRow').removeClass('IsRequested');
                var element = $(e.target);
                var parent = element.parent();
                var optionsClicked = null;
                if (element.hasClass('BtnPreSchedulesGroupOptions') || element.hasClass('BtnPreSchedulesGroupAttemptOptions')) {
                    optionsClicked = element;
                }
                if (parent.hasClass('PreScheduleGroupRow') || parent.hasClass('PreScheduleAttempRow')) {
                    element = parent;
                }
                if (parent.hasClass('GroupName')) {
                    element = parent.parent();
                }
                if (element.hasClass('PreScheduleGroupRow')) {
                    var preScheduleAttemps = $('.PreScheduleAttemps', element);
                    element.addClass('IsSelected');
                    if (optionsClicked != null && optionsClicked.hasClass('BtnPreSchedulesGroupOptions')) {
                        menuDisplayed = true;
                        let data = GetDataGroupAndAttemptId(element);
                        CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/GetPreScheduleGroupMenuButtons/" + CSParameters.SportEventId, data, function (queryResult) {
                            ClearLastMenu();
                            var body = $('body');
                            var menu = $(queryResult);
                            menu.appendTo(body);
                            menu.css('left', (optionsClicked.offset().left + optionsClicked.outerWidth() - body.offset().left) + 'px');
                            var menuTop = optionsClicked.offset().top - body.offset().top;
                            var menuHeight = menu.height();
                            if (menuTop + menuHeight >= body.height()) {
                                menu.css('bottom', 0);
                            }
                            else {
                                menu.css('top', (menuTop) + 'px');
                            }
                            lastMenu = menu;
                            optionsClicked.addClass("IsSelected");
                            BindPreScheduleGroupRowMenus();
                            if (IsDefined(typeof (CS.docHtml))) {
                                CS.docHtml.trigger('panelopened', optionsClicked[0].id);
                            }
                        });
                    }
                    else if (preScheduleAttemps.is(':visible')) {
                        preScheduleAttemps.slideUp(100);
                        $('.Expandable', element).addClass('IsNotExpanded');
                        $('.Expandable', element).removeClass('IsExpanded');
                        $('.Expandable', element).html('+');
                    }
                    else {
                        let data = GetDataGroupAndAttemptId(element);
                        GetPreSchedulesGroupAttempts(data);
                    }
                }
                else if (element.hasClass('PreScheduleAttempRow')) {
                    if (optionsClicked != null && optionsClicked.hasClass('BtnPreSchedulesGroupAttemptOptions')) {
                        menuDisplayed = true;
                        let data = GetDataGroupAndAttemptId(element);
                        CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/GetPreScheduleGroupAttemptMenuButtons/" + CSParameters.SportEventId, data, function (queryResult) {
                            ClearLastMenu();
                            var body = $('body');
                            var menu = $(queryResult);
                            menu.appendTo(body);
                            menu.css('left', (optionsClicked.offset().left + optionsClicked.outerWidth() - body.offset().left) + 'px');
                            var menuTop = optionsClicked.offset().top - body.offset().top;
                            var menuHeight = menu.height();
                            if (menuTop + menuHeight >= body.height()) {
                                menu.css('bottom', 0);
                            }
                            else {
                                menu.css('top', (menuTop) + 'px');
                            }
                            lastMenu = menu;
                            optionsClicked.addClass("IsSelected");
                            BindPreScheduleAttemptRowMenus();
                            if (IsDefined(typeof (CS.docHtml))) {
                                CS.docHtml.trigger('panelopened', optionsClicked[0].id);
                            }
                        });
                    }
                    else {
                        element.addClass('IsSelected');
                    }
                }
            });
            function ClearLastMenu() {
                if (lastMenu != null) {
                    $(".BtnPreSchedulesGroupOptions").removeClass("IsSelected");
                    $(".BtnPreSchedulesGroupAttemptOptions").removeClass("IsSelected");
                    lastMenu.detach().remove();
                }
            }
            function BindPreScheduleGroupRowMenus() {
                $('.BtnEditRecurringDates').off('click');
                $('.BtnEditRecurringDates').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    let popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "",
                        Url: CSParameters.RUrl + 'SchedulesGenerator/EditRecurringDates/' + CSParameters.SportEventId,
                        Data: data,
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    popup.OnClosing = function () {
                        GetPreScheduleGroupRow(data);
                    };
                    /*
                    ShowFormPopup(CSParameters.RUrl + 'SchedulesGenerator/EditRecurringDates/' + CSParameters.SportEventId, data, null, null, function (response) {
                        GetPreScheduleGroupRow(data);
                    });
                    */
                });
                $('.BtnEditDivisions').off('click');
                $('.BtnEditDivisions').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    let popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "",
                        Url: CSParameters.RUrl + 'SchedulesGenerator/EditPreScheduleGroupFlowBlocks/' + CSParameters.SportEventId,
                        Data: data,
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    popup.OnPosted = function (response) {
                        GetPreScheduleGroupRow(data);
                    };
                    /*
                    ShowFormPopup(CSParameters.RUrl + 'SchedulesGenerator/EditPreScheduleGroupFlowBlocks/' + CSParameters.SportEventId, data, null, function (response) {
                        $(this).dialog("close");
                        GetPreScheduleGroupRow(data);
                    });
                    */
                });
                $('.BtnEditGroup').off('click');
                $('.BtnEditGroup').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    data.isNew = false;
                    let popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "",
                        Url: CSParameters.RUrl + 'SchedulesGenerator/EditPreSchedulesGroup/' + CSParameters.SportEventId,
                        Data: data,
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    popup.OnPosted = function (response) {
                        //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
                        if ($('form', response).length == 0) {
                            GetPreScheduleGroupRow(data);
                        }
                    };
                    /*
                    ShowFormPopup(CSParameters.RUrl + 'SchedulesGenerator/EditPreSchedulesGroup/' + CSParameters.SportEventId, data, null, function (response) {
                        //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
                        if ($('form', response).length == 0) {
                            $(this).dialog("close");
                            GetPreScheduleGroupRow(data);
                        }
                    });
                    */
                });
                $('.BtnGenerateSchedules').off('click');
                $('.BtnGenerateSchedules').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    let popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "",
                        Url: CSParameters.RUrl + 'SchedulesGenerator/GenerateSchedules/' + CSParameters.SportEventId,
                        Data: data,
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    popup.OnShowed = function () {
                        let $btnSurfacesFilter = $('#BtnSurfacesFilter');
                        let shouldReloadSurfacesFilter = true;
                        $btnSurfacesFilter.off('click.generatesurfacesfilter');
                        $btnSurfacesFilter.on('click.generatesurfacesfilter', () => {
                            let forceReload = shouldReloadSurfacesFilter;
                            shouldReloadSurfacesFilter = false;
                            Schedules.desktop.ShowHideSurfacesFilterPanel($btnSurfacesFilter, (ids) => {
                                $('#FilteredSurfacesIds').val(ids);
                            }, forceReload);
                        });
                    };
                    popup.OnPosted = function (response) {
                        if (response.success == true) {
                            GetPreScheduleGroupRow(data);
                            // var data = GetDataGroupAndAttemptId(this);
                            $('#updateFilter').val('true');
                            hiddenGroupId.val(response.groupId);
                            hiddenAttemptId.val(response.attemptId);
                            hiddenShowAllSchedule.val('false');
                            Schedules.desktop.RefreshSchedules(true);
                        }
                        else {
                            var popup2 = new CompuSport.Controls.Popup();
                            popup2.Show(response, { PopupId: 'ApplyChangeToMyAccountConfirmed', Buttons: 'Ok' });
                        }
                    };
                    /*
                    ShowFormPopup(CSParameters.RUrl + 'SchedulesGenerator/GenerateSchedules/' + CSParameters.SportEventId, data, null,
                        function (response) {
                            if (response.success == true) {
                                $(this).dialog("close");
                                GetPreScheduleGroupRow(data);
                            }
                        });
                    */
                });
                $('.BtnDeleteGroup').off('click');
                $('.BtnDeleteGroup').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    CompuSport.Controls.Popup.ShowConfirmDialogV2('', JSRess.DeleteSchedulingGroup, function () {
                        CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/DeletePreSchedulesGroup/" + CSParameters.SportEventId, data, function (queryResult) {
                            var element = GetGroupElement(data.groupId);
                            element.remove();
                        });
                    });
                    //var result = ShowConfirmDialog();
                    //let data = GetDataGroupAndAttemptId(this);
                    //result.Ok = function () {
                    //    $.ajaxAntiForgery({
                    //        cache: false,
                    //        type: "POST",
                    //        url: CSParameters.RUrl + "SchedulesGenerator/DeletePreSchedulesGroup/" + CSParameters.SportEventId,
                    //        data: data,
                    //        success: function (queryResult) {
                    //            var element = GetGroupElement(data.groupId);
                    //            element.remove();
                    //        }
                    //    });
                    //};
                });
                $('.BtnViewStats').off('click');
                $('.BtnViewStats').on('click', function (e) {
                    // e.preventDefault();
                    OpenReport('PDF', 'SchedulingReport', this);
                });
                $('.BtnUpdateSchedulesFilter').off('click');
                $('.BtnUpdateSchedulesFilter').on('click', function (e) {
                    e.preventDefault();
                    $('#updateFilter').val('true');
                    $('#AttemptName').html("");
                    let data = GetDataGroupAndAttemptId(this);
                    hiddenShowAllSchedule.val('false');
                    hiddenGroupId.val(data.groupId);
                    hiddenAttemptId.val(data.attemptId);
                    Schedules.desktop.RefreshSchedules(true);
                });
                $('.BtnPrintRotationSchedule').off('click');
                $('.BtnPrintRotationSchedule').on('click', function (e) {
                    // e.preventDefault();
                    OpenReport('PDF', 'LeagueScheduleBerger', this);
                });
                $('.BtnExportScriptSchedule').off('click');
                $('.BtnExportScriptSchedule').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    hiddenGroupId.val(data.groupId);
                    hiddenAttemptId.val(null);
                    var reportParam = "?groupId=" + data.groupId;
                    var url = CSParameters.RUrl + "SchedulesGenerator/ExportScriptSchedule/" + CSParameters.SportEventId + reportParam;
                    window.location.replace(url);
                    CS.win.trigger("downloadfinished");
                });
                $('.BtnExportDataForUnitTest').off('click');
                $('.BtnExportDataForUnitTest').on('click', function (e) {
                    e.preventDefault();
                    var data = GetDataGroupAndAttemptId(this);
                    hiddenGroupId.val(data.groupId);
                    hiddenAttemptId.val(null);
                    var reportParam = "?groupId=" + data.groupId;
                    var url = CSParameters.RUrl + "SchedulesGenerator/ExportDataForUnitTest/" + CSParameters.SportEventId + reportParam;
                    window.location.replace(url);
                    CS.win.trigger("downloadfinished");
                });
                $('.BtnCopySchedule').off('click');
                $('.BtnCopySchedule').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    hiddenGroupId.val(data.groupId);
                    data.tryFixAttempt = false;
                    CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/TryToFixExistingSchedule/" + CSParameters.SportEventId, data, function (queryResult) {
                        GetPreScheduleGroupRow(data);
                    });
                });
                $('.BtnTryToFixExistingSchedule').off('click');
                $('.BtnTryToFixExistingSchedule').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    hiddenGroupId.val(data.groupId);
                    data.tryFixAttempt = true;
                    CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/TryToFixExistingSchedule/" + CSParameters.SportEventId, data, function (queryResult) {
                        GetPreScheduleGroupRow(data);
                    });
                });
            }
            function OpenReport(actionToDo, reportName, me) {
                let data = GetDataGroupAndAttemptId(me);
                //   ShowFormPopup(CSParameters.RUrl + 'SchedulesGenerator/ViewStatPreScheduleGroup/' + CSParameters.SportEventId, data);
                var reportParam = "?ReportName=" + reportName + // "SchedulingReport" +
                    "&preScheduleAttemptId=" + data.attemptId +
                    "&preScheduleGroupId=" + data.groupId;
                me.target = "_blank";
                reportParam = reportParam + "&ShowReportViewer=false";
                // me.href = CSParameters.RUrl + "Printing/Print/" + CSParameters.SportEventId + reportParam;
                // ShowFormPopup(CSParameters.RUrl + "Printing/Print/" + CSParameters.SportEventId + reportParam);
                window.open(CSParameters.RUrl + "Printing/Print/" + CSParameters.SportEventId + reportParam);
            }
            function BindPreScheduleAttemptRowMenus() {
                $('.BtnAcceptAttempt').off('click');
                $('.BtnAcceptAttempt').on('click', function (e) {
                    e.preventDefault();
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    CompuSport.Controls.Popup.ShowConfirmDialogV2('', JSRess.AreYouSure, function () {
                        /*regarder si contient des not a home*/
                        CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/GetNotAtHomeCount/" + CSParameters.SportEventId, data, function (response) {
                            var notAtHomeCount = response.notAtHomeCount;
                            var doubleSurface = response.doubleSurface;
                            if (doubleSurface != "" && doubleSurface > 0) {
                                CompuSport.Controls.Popup.ShowWarningDialog(response.doublematchmsg);
                                return; //stop the process
                            }
                            else {
                                if (notAtHomeCount != "" && notAtHomeCount > 0) {
                                    CompuSport.Controls.Popup.ShowConfirmDialogV2('', response.confirmationmsg, function () {
                                        AcceptPreScheduleAttempt(data);
                                    });
                                }
                                else {
                                    AcceptPreScheduleAttempt(data);
                                }
                            }
                        });
                    });
                });
                function AcceptPreScheduleAttempt(data) {
                    $('#AttemptName').html("");
                    CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/AcceptPreScheduleAttempt/" + CSParameters.SportEventId, data, function (queryResult) {
                        if (queryResult != "") {
                            CompuSport.Controls.Popup.ShowWarningDialog(queryResult);
                        }
                        GetPreScheduleGroupRow(data);
                    });
                }
                $('.BtnDeleteAttempt').off('click');
                $('.BtnDeleteAttempt').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    CompuSport.Controls.Popup.ShowConfirmDialogV2('', JSRess.AreYouSure, function () {
                        CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/DeletePreScheduleAttempt/" + CSParameters.SportEventId, data, function (queryResult) {
                            GetPreScheduleGroupRow(data);
                        });
                    });
                    //var result = ShowConfirmDialog();
                    //result.Ok = function () {
                    //    $.ajaxAntiForgery({
                    //        cache: false,
                    //        type: "POST",
                    //        url: CSParameters.RUrl + "SchedulesGenerator/DeletePreScheduleAttempt/" + CSParameters.SportEventId,
                    //        data: data,
                    //        success: function (queryResult) {
                    //            GetPreScheduleGroupRow(data);
                    //        }
                    //    });
                    //};
                });
                $('.BtnEditAttempts').off('click');
                $('.BtnEditAttempts').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    let popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "EditAttempts",
                        Url: CSParameters.RUrl + 'SchedulesGenerator/EditPreSchedulesGroupAttempt/' + CSParameters.SportEventId,
                        Data: data,
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    popup.OnPosted = function (response) {
                        GetPreSchedulesGroupAttempts(data);
                    };
                    /*
                    ShowFormPopup(CSParameters.RUrl + 'SchedulesGenerator/EditPreSchedulesGroupAttempt/' + CSParameters.SportEventId, data, null, function (response) {
                        $(this).dialog("close");
                        GetPreSchedulesGroupAttempts(data);
                    });
                    */
                });
                $('.BtnViewStats').off('click');
                $('.BtnViewStats').on('click', function (e) {
                    e.preventDefault();
                    OpenReport('PDF', 'SchedulingReport', this);
                });
                $('.BtnPrintRotationSchedule').off('click');
                $('.BtnPrintRotationSchedule').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    var reportParam = "?preScheduleAttemptId=" + data.attemptId + "&preScheduleGroupId=" + data.groupId;
                    this.target = "_blank";
                    window.open(CSParameters.RUrl + "Schedules/BergerScheduleAttempt/" + CSParameters.SportEventId + reportParam);
                });
                $('.BtnUpdateSchedulesFilter').off('click');
                $('.BtnUpdateSchedulesFilter').on('click', function (e) {
                    e.preventDefault();
                    $('#updateFilter').val('true');
                    let data = GetDataGroupAndAttemptId(this);
                    hiddenGroupId.val(data.groupId);
                    hiddenAttemptId.val(data.attemptId);
                    hiddenShowAllSchedule.val('false');
                    Schedules.desktop.RefreshSchedules(true);
                    $('#AttemptName').html(data.attemptname);
                });
                $('.BtnUpdateAllSchedulesFilter').off('click');
                $('.BtnUpdateAllSchedulesFilter').on('click', function (e) {
                    e.preventDefault();
                    $('#updateFilter').val('true');
                    let data = GetDataGroupAndAttemptId(this);
                    hiddenGroupId.val(data.groupId);
                    hiddenAttemptId.val(data.attemptId);
                    hiddenShowAllSchedule.val('true');
                    Schedules.desktop.RefreshSchedules(true);
                });
                $('.BtnExportScriptSchedule').off('click');
                $('.BtnExportScriptSchedule').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    hiddenGroupId.val(data.groupId);
                    hiddenAttemptId.val(data.attemptId);
                    var reportParam = "?groupId=" + data.groupId + "&attemptId=" + data.attemptId;
                    var url = CSParameters.RUrl + "SchedulesGenerator/ExportScriptSchedule/" + CSParameters.SportEventId + reportParam;
                    window.location.replace(url);
                    CS.win.trigger("downloadfinished");
                });
                $('.BtnExportDataForUnitTest').off('click');
                $('.BtnExportDataForUnitTest').on('click', function (e) {
                    e.preventDefault();
                    var data = GetDataGroupAndAttemptId(this);
                    hiddenGroupId.val(data.groupId);
                    hiddenAttemptId.val(null);
                    var reportParam = "?groupId=" + data.groupId;
                    var url = CSParameters.RUrl + "SchedulesGenerator/ExportDataForUnitTest/" + CSParameters.SportEventId + reportParam;
                    window.location.replace(url);
                    CS.win.trigger("downloadfinished");
                });
                $('.BtnCopySchedule').off('click');
                $('.BtnCopySchedule').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    hiddenGroupId.val(data.groupId);
                    data.tryFixAttempt = false;
                    CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/TryToFixExistingSchedule/" + CSParameters.SportEventId, data, function (queryResult) {
                        GetPreScheduleGroupRow(data);
                    });
                });
                $('.BtnTryToFixExistingSchedule').off('click');
                $('.BtnTryToFixExistingSchedule').on('click', function (e) {
                    e.preventDefault();
                    let data = GetDataGroupAndAttemptId(this);
                    hiddenGroupId.val(data.groupId);
                    hiddenAttemptId.val(data.attemptId);
                    data.tryFixAttempt = true;
                    CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/TryToFixExistingSchedule/" + CSParameters.SportEventId, data, function (queryResult) {
                        GetPreScheduleGroupRow(data);
                    });
                });
            }
            function GetPreScheduleGroupRow(data) {
                var actualPreScheduleRow = $('.PreScheduleGroupRow[data-groupid=' + data.groupId + ']');
                CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/GetPreScheduleGroupRow/" + CSParameters.SportEventId, data, function (queryResult) {
                    actualPreScheduleRow.replaceWith(queryResult.Value);
                });
            }
            function GetPreSchedulesGroupAttempts(data) {
                CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/GetPreSchedulesGroupAttempts/" + CSParameters.SportEventId, data, function (queryResult) {
                    if (queryResult != "") {
                        var groupElement = GetGroupElement(data.groupId);
                        var attemptElement = $('.PreScheduleAttemps', groupElement);
                        attemptElement[0].innerHTML = queryResult;
                        $('.Expandable', groupElement).html('-');
                        $('.Expandable', groupElement).removeClass('IsNotExpanded');
                        $('.Expandable', groupElement).addClass('IsExpanded');
                        attemptElement.slideDown(100, "swing", function () {
                            if (IsDefined(typeof (CS.docHtml))) {
                                CS.docHtml.trigger('panelopened', data.groupId);
                            }
                        });
                    }
                });
            }
            function GetDataGroupAndAttemptId(element) {
                let data = {
                    groupId: undefined,
                    attemptId: undefined,
                    isNew: undefined,
                    tryFixAttempt: undefined,
                    attemptname: undefined
                };
                var $element = $(element);
                if ($element.data('groupid') != null) {
                    data.groupId = $element.data('groupid');
                    data.attemptId = $element.data('attemptid');
                    data.attemptname = $element.data('attemptname');
                }
                else {
                    data.groupId = $element.parent().data('groupid');
                    data.attemptId = $element.parent().data('attemptid');
                    data.attemptname = $element.parent().data('attemptname');
                }
                if (typeof (data.attemptId) == 'undefined') {
                    data.attemptId = null;
                }
                return data;
            }
            function GetGroupElement(groupId) {
                return $('.PreScheduleGroupRow[data-groupid=' + groupId + ']');
            }
            function GetAttemptsOfGroupElement(groupId) {
                var groupElement = GetGroupElement(groupId);
                return $('.PreScheduleAttemps', groupElement);
            }
            CS.FormReady(function (formId) {
                if (formId == "EditRecurringDates") {
                    var form = $(this);
                    var btnAddRecurringDates = $('#BtnAddRecurringDates', form);
                    //   var editRecurringDatesFlowBlockId =  $('#EditRecurringDatesFlowBlockId', form);
                    btnAddRecurringDates.off('click');
                    btnAddRecurringDates.on('click', function (e) {
                        e.preventDefault();
                        let data = {
                            EditRecurringDatesGroupId: $('#EditRecurringDatesGroupId', form).val()
                        };
                        let popup = new CompuSport.Controls.Popup();
                        popup.GetAndShow({
                            PopupId: "AddRecurringDates",
                            Url: CSParameters.RUrl + 'SchedulesGenerator/AddRecurringDates/' + CSParameters.SportEventId,
                            Data: data,
                            AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                        });
                        popup.OnPosted = function (response) {
                            if (response.success) {
                                gridViewPreScheduleDates.RefreshGridData();
                            }
                        };
                        /*
                        ShowFormPopup(CSParameters.RUrl + 'SchedulesGenerator/AddRecurringDates/' + CSParameters.SportEventId, data, null,
                            function (response) {
                                if (response.success) {
                                    gridViewPreScheduleDates.RefreshGridData();
                                }
                                $(this).dialog("close");
                            });
                        */
                    });
                    $("#EditRecurringDatesFlowBlockId").controlIsLoaded(function (dropdown) {
                        dropdown.SelectionChange = function () {
                            var lastVal = dropdown.GetValue(dropdown.$LastSelectedItem, 'text');
                            var newVal = dropdown.GetSelectedItemValue("value");
                            if (newVal != null) {
                                $('#BtnAddRecurringDates').hide();
                            }
                            else {
                                $('#BtnAddRecurringDates').show();
                            }
                            gridViewPreScheduleDates.RefreshGridData();
                        };
                    });
                }
                if (formId == "AddRecurringDates") {
                    var formrec = $(this);
                    var startDate = $('#ScheduleGeneratorStartDate', formrec);
                    var endDate = $('#ScheduleGeneratorEndDate', formrec);
                    var nbweek = $('#NbWeeks', formrec);
                    startDate.on('CSChange', function () {
                        var w = weeksBetween(new Date(startDate.val()), new Date(endDate.val()));
                        nbweek.html(JSRess.WeeksSelected + ' ' + w);
                    });
                    endDate.on('CSChange', function () {
                        var w = weeksBetween(new Date(startDate.val()), new Date(endDate.val()));
                        nbweek.html(JSRess.WeeksSelected + ' ' + w);
                    });
                    var w = weeksBetween(new Date(startDate.val()), new Date(endDate.val()));
                    nbweek.html(JSRess.WeeksSelected + ' ' + w);
                }
            });
            function weeksBetween(d1, d2) {
                return Math.round((d2 - d1) / (7 * 24 * 60 * 60 * 1000)) + 1;
            }
            CS.FormReady(function (formId) {
                if (formId == "EditPreScheduleDate") {
                    var form = $(this);
                    var btnAddRecurringDates = $('#BtnAddRecurringDates', form);
                    //   var editRecurringDatesFlowBlockId =  $('#EditRecurringDatesFlowBlockId', form);
                    btnAddRecurringDates.off('click');
                    btnAddRecurringDates.on('click', function (e) {
                        e.preventDefault();
                        let data = {
                            EditRecurringDatesGroupId: $('#EditRecurringDatesGroupId', form).val()
                        };
                        let popup = new CompuSport.Controls.Popup();
                        popup.GetAndShow({
                            PopupId: "",
                            Url: CSParameters.RUrl + 'SchedulesGenerator/AddRecurringDates/' + CSParameters.SportEventId,
                            Data: data,
                            AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                        });
                        popup.OnPosted = function (response) {
                            if (response.success) {
                                gridViewPreScheduleDates.RefreshGridData();
                            }
                        };
                        /*
                        ShowFormPopup(CSParameters.RUrl + 'SchedulesGenerator/AddRecurringDates/' + CSParameters.SportEventId, data, null,
                            function (response) {
                                if (response.success) {
                                    gridViewPreScheduleDates.RefreshGridData();
                                }
                                $(this).dialog("close");
                            });
                        */
                    });
                    $("#EditRecurringDatesFlowBlockId").controlIsLoaded(function (dropdown) {
                        dropdown.SelectionChange = function () {
                            var lastVal = dropdown.GetValue(dropdown.$LastSelectedItem, 'text');
                            var newVal = dropdown.GetSelectedItemValue("value");
                            if (newVal != null) {
                                $('#BtnAddRecurringDates').hide();
                            }
                            else {
                                $('#BtnAddRecurringDates').show();
                            }
                            gridViewPreScheduleDates.RefreshGridData();
                        };
                    });
                    if (document.IsReservedSchedule.val() == true) {
                        $('#ReservedScheduleExplanation', form).parents(".CSInput").show();
                    }
                    else {
                        $('#ReservedScheduleExplanation', form).parents(".CSInput").hide();
                    }
                    document.IsReservedSchedule.SelectionChange = function () {
                        if (this.val() == true) {
                            $('#ReservedScheduleExplanation', form).parents(".CSInput").show();
                        }
                        else {
                            $('#ReservedScheduleExplanation', form).val("");
                            $('#ReservedScheduleExplanation', form).parents(".CSInput").hide();
                        }
                    };
                }
            });
            //function ChangeHiddenField() {
            //    let allids = "";
            //    let allradio = $('.RadioTeamNeedBye');
            //    $.each(allradio, function () {
            //        let name = $(this).data('name');
            //        let rad = $("[name=" + name + "]:checked").val();
            //        if (allids != "") {
            //            allids = allids + ",";
            //        }
            //        if (rad != null) {
            //            allids = allids + rad;
            //        }               
            //    });
            //    $('#NeededByesIds').val(allids);
            //}
            //$(document).on('change', 'input[type="radio"]', function () {
            //    setTimeout(function () {
            //        ChangeHiddenField();
            //    }, 500);
            //});
            //$(document).on('mouseup', 'input[type="radio"]', function () {
            //    let thisRadio = $(this);
            //    if (thisRadio.prop('checked')) {
            //        let end = thisRadio.length;
            //        for (var i = 0; i < end; i++) {
            //            let $radio = $(thisRadio[i]);
            //            $radio.checked = false;
            //            $radio.prop('checked', false);
            //        }
            //        thisRadio.prop('checked', false);
            //        thisRadio.removeAttr("checked");
            //        thisRadio.one('click', function () { thisRadio.prop('checked', false); });
            //    }
            //});
        }
        desktop.BindPreSchedulesControls = BindPreSchedulesControls;
    })(desktop = SchedulesGenerator.desktop || (SchedulesGenerator.desktop = {}));
})(SchedulesGenerator || (SchedulesGenerator = {}));

//# sourceMappingURL=SchedulesGenerator.desktop.js.map
